import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router";
import { Auth as AwsAuth } from "aws-amplify";

export default function PrivateRoute({ render, ...other }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthenticated();
  }, []);

  const checkAuthenticated = async () => {
    setIsLoading(true);
    await AwsAuth.currentAuthenticatedUser()
      .then((data) => {
        if (data) setIsAuthenticated(true);
      })
      .catch((err) => {
        //console.log("current session error", err)
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) {
    return <div></div>;
  }

  return (
    <Route
      {...other}
      render={
        isAuthenticated
          ? render
          : (props) => (
              <Redirect
                to={{ pathname: "/login", state: { from: props.location } }}
              />
            )
      }
    />
  );
}
